import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Row,
  Form,
  Modal,
  Dropdown,
  DropdownButton,
  ButtonGroup,
} from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../../_metronic/layout";
import { WithRtvTable } from "./WithRtvTable";
import { WithRtvNonRefTable } from "./WithRtvNonRefTable";
import { useSelector, useDispatch, batch } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  resetData,
  selectData,
  selectDataMaterial,
  selectLoading,
  selectPageNo,
  selectPageSize,
  selectTotalRecord,
  selectRtv,
  fetchAll,
  fetchMaterial,
} from "./withrtvSlice";
import {
  formatDate,
  StatusFormatter,
  sizePerPageList,
  showDialog,
  useForceUpdate,
  StatusCrpFormatter,
  formatCurrency,
  showErrorDialog,
  showConfirmDialog,
  showSuccessDialog,
} from "../../../utility";
import {
  sortCaret,
  headerSortingClasses,
} from "../../../../_metronic/_helpers";
import LoadingFetchData from "../../../utility/LoadingFetchData";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import {
  postSynchNrablank,
  postSynchNracustx,
  postSynchNrax,
  postSynchNracustblank,
  postSynchMaterial,
  postSynchCrprgp,
  postSynchBatch,
  postSynchCustomer,
  postSynchMaterialExt,
} from "../../administrator/general-setting/generalSettingSlice";
import { selectUser } from "../../../modules/Auth/_redux/authRedux";

export const WithRtvPage = (props) => {
  const dispatch = useDispatch();
  const data = useSelector(selectData);
  const dataMaterial = useSelector(selectDataMaterial);
  const dataRtv = useSelector(selectRtv);
  const loading = useSelector(selectLoading);
  const pageNo = useSelector(selectPageNo);
  const pageSize = useSelector(selectPageSize);
  const totalRecord = useSelector(selectTotalRecord);
  const history = useHistory();
  const forceUpdate = useForceUpdate();

  const user = useSelector(selectUser);
  const plants = user.plants.map((e) => {
    return e.plantCode;
  });

  console.log(props, "props");

  // Filter
  const [invoiceNo, setInvoiceNo] = useState("");
  const [taxInvoice, setTaxInvoice] = useState("");
  const [poNumber, setPoNumber] = useState("");
  const [materialCodeFilter, setMaterialCodeFilter] = useState("");
  const [materialNameFilter, setMaterialNameFilter] = useState("");

  // useEffect(() => {
  //   async function fetchMyAPI() {
  //     // Reset on first load
  //     await dispatch(resetData());
  //   }

  //   fetchMyAPI();
  // }, [dispatch]);
  // useEffect(() => {
  //   const npwp = props.location.state;
  //   if (cekGet === true) {
  //     setReloadGet(true);
  //   }
  // }, []);

  // Modal Invoice
  const [showInvoice, setShowInvoice] = useState(false);
  const handleCloseInvoice = () => {
    setInvoiceNo("");
    setTaxInvoice("");
    setPoNumber("");
    setMaterialCodeFilter("");
    setMaterialNameFilter("");
    setDataInvoice([]);
    setShowInvoice(false);
  };
  const handleShowInvoice = () => setShowInvoice(true);
  const [onSelectAllInvoice, setOnSelectAllInvoice] = useState(false);
  const [selectedRowsInvoice, setSelectedRowsInvoice] = useState([]);
  const [tableDataInvoice, setTableDataInvoice] = useState([]);

  const [overlayStateInvoice, setOverlayStateInvoice] = useState(false);

  const [showResultsInvoice, setShowResultsInvoice] = useState(false);

  const handleSearchInvoice = async () => {
    setOverlayStateInvoice(true);

    const params = {
      invoiceNo: invoiceNo.replace(/\s/g, ""),
      taxInvoice: taxInvoice,
      po: poNumber,
      materialCode: materialCodeFilter,
      materialName: materialNameFilter,
      customerCode: dataRtv.customerCode,
      customerName: dataRtv.customerName,
      plantCode: plants.toString(),
      pageNo: 1,
      pageSize: 10,
    };
    await callApiInvoice(params);
  };

  const handleTableChangeInvoice = async (
    type,
    { page, sizePerPage, sortField, sortOrder, data }
  ) => {
    const params = {
      invoiceNo: invoiceNo.replace(/\s/g, ""),
      taxInvoice: taxInvoice,
      po: poNumber,
      materialCode: materialCodeFilter,
      materialName: materialNameFilter,
      customerCode: dataRtv.customerCode,
      customerName: dataRtv.customerName,
      plantCode: plants.toString(),
      pageNo: page,
      pageSize: sizePerPage,
    };

    if (type === "pagination") {
      setOverlayStateInvoice(true);

      await callApiInvoice(params);
    } else {
      let result;
      if (sortOrder === "asc") {
        result = data.sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return 1;
          } else if (b[sortField] > a[sortField]) {
            return -1;
          }
          return 0;
        });
        console.log(result, "asc");
      } else {
        result = data.sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return -1;
          } else if (b[sortField] > a[sortField]) {
            return 1;
          }
          return 0;
        });
        console.log(result, "desc");
      }
    }
  };

  const callApiInvoice = async (params) => {
    try {
      const response = await dispatch(fetchAll(params));
      if (response.payload.status === 200) {
        setOverlayStateInvoice(false);
        setShowResultsInvoice(true);
        setSelectedRowsInvoice([]);
        if (response.payload.data.length < 1) {
          const action = await showConfirmDialog(
            `Invoice Reff does not exist or has Non-TF status or not relevant in your branch. Do you want to create Non-reference Return?`
          );
          if (action.isConfirmed);
          await handleCloseInvoice();
          await handleShowMaterial();
        }
      } else {
        setOverlayStateInvoice(false);
        showErrorDialog(response.payload.message);
      }
    } catch (error) {
      setOverlayStateInvoice(false);

      console.log(error);
      showErrorDialog("eror something wrong");
    }
  };

  const optionsInvoice = {
    page: pageNo,
    sizePerPage: pageSize,
    showTotal: true,
    totalSize: totalRecord,
    sizePerPageList: sizePerPageList,
  };
  const [dataInvoice, setDataInvoice] = useState(data);

  useEffect(() => {
    // Add number
    const pageBefore = pageSize * (pageNo - 1);
    const initData = data.map((item, index) => {
      return {
        ...item,
        no: index + 1 + pageBefore,
        blockRemark: checkValue(item),
        npwp: props.location.state,
      };
    });
    setDataInvoice(initData);
  }, [data, pageSize, pageNo]);

  let notSelectableRowsInvoice = [];

  const getNonSelectableRowsInvoice = (payload) => {
    let nonSelectable = [];
    payload.map((value, index) => {
      if (value.customerBlocked === true) {
        nonSelectable.push(index);
      } else if (value.batchStatus === false) {
        nonSelectable.push(index);
      } else if (value.blocked === true) {
        nonSelectable.push(index);
      } else if (value.materialExcluded === true) {
        nonSelectable.push(index);
      } else if (value.crprgp === "N/A") {
        nonSelectable.push(index);
      } else if (value.availableQty === "0") {
        nonSelectable.push(index);
      } else if (value.netPrice === "0") {
        nonSelectable.push(index);
      }
    });

    return nonSelectable;
  };

  notSelectableRowsInvoice = getNonSelectableRowsInvoice(data);

  const onSelectRowInvoice = {
    clickToSelect: true,
    hideSelectAll: notSelectableRowsInvoice.length > 0 ? true : false,
    nonSelectable: notSelectableRowsInvoice,
    nonSelectableStyle: { backgroundColor: "gray" },
    mode: "checkbox",
    hideSelectAll: true,
    onSelectAllInvoice: (status) => {
      setOnSelectAllInvoice(status);
    },
    onSelect: (row, isSelect, rowIndex) => {
      if (isSelect) {
        setSelectedRowsInvoice([...selectedRowsInvoice, row]);
      } else {
        const index = selectedRowsInvoice.indexOf(row);
        if (index > -1) {
          selectedRowsInvoice.splice(index, 1);
          setSelectedRowsInvoice(selectedRowsInvoice);
        }
      }
      // return selectedRows;
    },
  };

  const rowClassesInvoice = (row, rowIndex) => {
    let classes = null;
    if (notSelectableRowsInvoice.includes(rowIndex)) {
      classes = "disabled-row-table";
    } else {
      classes = "enable-row-table";
    }
    return classes;
  };

  const handleDeleteRowInvoice = (uuid, dataTableOld, cell) => {
    const oldTable = dataTableOld;
    const idColumn = uuid;

    let tableDataInvoiceNew = oldTable.filter(
      (value, index) => value.uuid !== idColumn
    );

    setSelectedRowsInvoice(tableDataInvoiceNew);
    setTableDataInvoice(tableDataInvoiceNew);
    forceUpdate();
  };

  const updateTableDataFromInvoiceTable = () => {
    let tableDataInvoiceNew = tableDataInvoice;
    setTableDataInvoice(selectedRowsInvoice);
    setShowInvoice(false);
    setInvoiceNo("");
    setTaxInvoice("");
    setPoNumber("");
    setMaterialCodeFilter("");
    setMaterialNameFilter("");
    setDataInvoice([]);
    forceUpdate();
  };

  const handleSubmit = () => {
    // Validation
    const result = selectedRowsInvoice.filter(
      (elem) =>
        !tableDataInvoice.find(
          ({ materialCode, batch }) =>
            elem.materialCode === materialCode && elem.batch === batch
        )
    );
    console.log(result, "result");
    setTableDataInvoice((tableDataInvoice) => [...tableDataInvoice, ...result]);
    forceUpdate();

    setSelectedRowsInvoice([]);
    setInvoiceNo("");
    setTaxInvoice("");
    setPoNumber("");
    setMaterialCodeFilter("");
    setMaterialNameFilter("");
    setDataInvoice([]);
    setShowInvoice(false);
  };

  // end invoice

  // Modal Material
  const [showMaterial, setShowMaterial] = useState(false);
  const [materialCode, setMaterialCode] = useState("");
  const [materialName, setMaterialName] = useState("");
  const [batch, setBatch] = useState("");
  const handleCloseMaterial = () => {
    setMaterialCode("");
    setMaterialName("");
    setBatch("");
    setShowMaterial(false);
    setTableDataMaterial([]);
  };
  const handleShowMaterial = () => setShowMaterial(true);
  const [onSelectAll, setOnSelectAll] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [tableData, setTableData] = useState([]);

  const [overlayStateMaterial, setOverlayStateMaterial] = useState(false);

  const [showResultsMaterial, setShowResultsMaterial] = useState(false);

  const rowClasses = (row, rowIndex) => {
    let classes = null;
    if (notSelectableRows.includes(rowIndex)) {
      classes = "disabled-row-table";
    } else {
      classes = "enable-row-table";
    }
    return classes;
  };

  //checker rowRemark
  const checkValue = (value) => {
    let remarkRow = "";
    if (value.customerBlocked === true) {
      remarkRow = "Customer Block.";
    } else if (value.batchStatus === false) {
      remarkRow = "Invalid Batch Number, Please Contact PAM";
    } else if (value.blocked === true) {
      remarkRow = "Material Block. Please Contact PAM";
    } else if (value.materialExcluded === true) {
      remarkRow = "Material Block Exclusion. Please Contact PAM";
    } else if (value.crprgp === "N/A") {
      remarkRow = "CRRGP Block. Please Contact NDC RG Team";
    } else if (value.nra === true) {
      remarkRow = "Non Returnable Client. Please contact NDC RG team";
    } else if (value.netPrice === "0") {
      remarkRow = "Non Returnable Net Price 0";
    } else {
      remarkRow = "";
    }
    return remarkRow;
  };

  //checker rowRemark
  const checkValueNonReference = (value) => {
    let remarkRow = "";
    if (value.customerBlocked === true) {
      remarkRow = "Customer Block.";
    } else if (value.batchStatus === false) {
      remarkRow = "Invalid Batch Number, Please Contact PAM";
    } else if (value.blocked === true) {
      remarkRow = "Material Block. Please Contact PAM";
    } else if (value.materialExcluded === true) {
      remarkRow = "Material Block Exclusion. Please Contact PAM";
    } else if (value.crprgp === "N/A") {
      remarkRow = "CRRGP Block. Please Contact NDC RG Team";
    } else if (value.nra === true) {
      remarkRow = "Non Returnable Client. Please contact NDC RG team";
    } else {
      remarkRow = "";
    }
    return remarkRow;
  };
  //

  const [tableDataMaterial, setTableDataMaterial] = useState(dataMaterial);

  useEffect(() => {
    // Add number
    const pageBefore = pageSize * (pageNo - 1);
    const initData = dataMaterial.map((item, index) => {
      return {
        ...item,
        no: index + 1 + pageBefore,
        blockRemark: checkValueNonReference(item),
      };
    });
    setTableDataMaterial(initData);
  }, [dataMaterial, pageSize, pageNo]);

  let notSelectableRows = [];

  const getNonSelectableRows = (payload) => {
    let nonSelectable = [];
    payload.map((value, index) => {
      if (value.customerBlocked === true) {
        nonSelectable.push(index);
      } else if (value.batchStatus === false) {
        nonSelectable.push(index);
      } else if (value.blocked === true) {
        nonSelectable.push(index);
      } else if (value.materialExcluded === true) {
        nonSelectable.push(index);
      } else if (value.crprgp === "N/A") {
        nonSelectable.push(index);
      }
    });

    return nonSelectable;
  };

  notSelectableRows = getNonSelectableRows(tableDataMaterial);

  const onSelectRow = {
    clickToSelect: true,
    hideSelectAll: notSelectableRows.length > 0 ? true : false,
    nonSelectable: notSelectableRows,
    nonSelectableStyle: { backgroundColor: "gray" },
    mode: "checkbox",
    hideSelectAll: true,
    onSelectAll: (status) => {
      setOnSelectAll(status);
    },
    onSelect: (row, isSelect, rowIndex) => {
      if (isSelect) {
        setSelectedRows([...selectedRows, row]);
      } else {
        const index = selectedRows.indexOf(row);
        if (index > -1) {
          selectedRows.splice(index, 1);
          setSelectedRows(selectedRows);
        }
      }
      // return selectedRows;
    },
  };

  const handleSearchMaterial = async () => {
    let valid = false;
    if (materialCode === "" && batch !== "") {
      valid = true;
    } else if (batch === "" && materialCode !== "") {
      valid = true;
    } else if (batch !== "" && materialCode !== "") {
      valid = true;
    }

    if (!valid) {
      return showDialog("Please Insert Material or Batch Code First!");
    }

    setOverlayStateMaterial(true);
    const params = {
      customerCode: dataRtv.customerCode,
      distributionChannel: dataRtv.distChannel,
      materialCode: materialCode,
      batch: batch,
      pageNo: 1,
      pageSize: 10,
    };
    await dispatch(fetchMaterial(params));
    setOverlayStateMaterial(false);
    setShowResultsMaterial(true);
  };

  const handleTableChangeMaterial = async (type, { page, sizePerPage }) => {
    setOverlayStateMaterial(true);
    const params = {
      customerCode: dataRtv.customerCode,
      distributionChannel: dataRtv.distChannel,
      materialCode: materialCode,
      batch: batch,
      pageNo: page,
      pageSize: sizePerPage,
    };
    await dispatch(fetchMaterial(params));
    setOverlayStateMaterial(false);
  };
  const optionsMaterial = {
    page: pageNo,
    sizePerPage: pageSize,
    showTotal: true,
    totalSize: totalRecord,
    sizePerPageList: sizePerPageList,
  };

  const handleDeleteRow = (uuid, dataTableOld, cell) => {
    const oldTable = dataTableOld;
    const idColumn = uuid;

    let tableDataNew = oldTable.filter(
      (value, index) => value.uuid !== idColumn
    );

    setSelectedRows(tableDataNew);
    setTableData(tableDataNew);
    forceUpdate();
  };

  const updateTableDataFromMaterialTable = () => {
    let tableDataNew = tableData;
    setTableData(selectedRows);
    setShowMaterial(false);
    setTableDataMaterial([]);
    setMaterialCode("");
    setMaterialName("");
    setBatch("");
    forceUpdate();
  };

  // end modal material

  const columnsMaterial = [
    { text: "uuid", dataField: "uuid", hidden: true },
    { text: "No", dataField: "no" },
    { text: "Material Code", dataField: "materialCode" },
    { text: "Material Description", dataField: "materialName" },
    { text: "Uom", dataField: "uom", align: "center" },
    {
      text: "Material Block",
      dataField: "blocked",
      formatter: StatusFormatter,
      align: "center",
    },
    {
      text: "Material Exclusion",
      dataField: "materialExcluded",
      formatter: StatusFormatter,
      align: "center",
    },

    {
      text: "NRA",
      dataField: "nra",
      formatter: StatusFormatter,
      align: "center",
    },
    {
      text: "Batch",
      dataField: "batch",
    },
    {
      text: "Exp Date",
      dataField: "expiredDate",
      formatter: formatDate,
      align: "center",
    },
    {
      text: "Exclusion Status",
      dataField: "materialExcluded",
      formatter: StatusFormatter,
      align: "center",
    },
    {
      text: "CRPRGP",
      dataField: "crprgp",
      formatter: StatusCrpFormatter,
      align: "center",
    },
    {
      text: "Block Remarks",
      dataField: "blockRemark",
    },
  ];

  const columnsInvoice = [
    {
      text: "No",
      dataField: "no",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Invoice Ref Num",
      dataField: "invoiceNo",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "invoice item number",
      dataField: "line",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "100px" },
    },
    {
      text: "Invoice Ref Date",
      dataField: "transactionDate",
      sort: true,
      formatter: formatDate,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "tax Invoice No",
      dataField: "taxInvoiceNo",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },
    {
      text: "purchase order",
      dataField: "po",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "Material",
      dataField: "materialCode",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Material Desc",
      dataField: "materialName",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },

    {
      text: "Client Code",
      dataField: "clientCode",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Client Name",
      dataField: "clientName",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
    },
    {
      text: "Division",
      dataField: "division",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Batch",
      dataField: "batch",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "80px" },
    },
    {
      text: "Exp Date",
      dataField: "expiredDate",
      sort: true,
      formatter: formatDate,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Avail Qty",
      dataField: "availableQty",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },

    {
      text: "Net Sales",
      dataField: "netPrice",
      formatter: formatCurrency,
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Customer Block",
      dataField: "customerBlocked",
      formatter: StatusFormatter,
      align: "center",
    },
    {
      text: "Material Block",
      dataField: "blocked",
      formatter: StatusFormatter,
      align: "center",
    },
    {
      text: "Material Exclusion",
      dataField: "materialExcluded",
      formatter: StatusFormatter,
      align: "center",
    },
    {
      text: "CRP/RGP",
      dataField: "crprgp",
      formatter: StatusCrpFormatter,
      align: "center",
    },
    {
      text: "Non Returnable",
      dataField: "nra",
      formatter: StatusFormatter,
    },
    {
      text: "FullBox",
      dataField: "nonFraction",
      formatter: StatusFormatter,
    },
    {
      text: "Block Remarks",
      dataField: "blockRemark",
    },
  ];

  // sync customer
  const [showCustomer, setShowCustomer] = useState(false);
  const [customerCodeSynch, setCustomerCodeSynch] = useState("");
  const [customerNameSynch, setCustomerNameSynch] = useState("");
  const handleCloseCustomer = () => setShowCustomer(false);
  const handleShowCustomer = () => setShowCustomer(true);

  const handleSynchCustomer = async () => {
    if (customerCodeSynch === "") {
      return showDialog("Please Fill Out Customer Code Field");
    }

    // customer code
    const params = {
      P_CustomerCode: customerCodeSynch,
      P_CustomerName: customerNameSynch,
    };
    try {
      const response = await dispatch(postSynchCustomer(params));
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.message);
        // if (action.isConfirmed) await window.location.reload();
      } else {
        showErrorDialog(response.payload.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  // synch CRP RGP

  const handleSynchCrprpg = async () => {
    const params = {};
    try {
      const response = await dispatch(postSynchCrprgp(params));
      console.log(response, "response");
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        // if (action.isConfirmed) await window.location.reload();
      } else {
        showErrorDialog(response.payload.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  // synch material
  const [materialSynch, setMaterialSynch] = useState("");
  const [distChannelSynch, setDistChannelSynch] = useState("");

  const [showMaterialSynch, setShowMaterialSynch] = useState(false);
  const handleCloseMaterialSynch = () => setShowMaterialSynch(false);
  const handleShowMaterialSynch = () => setShowMaterialSynch(true);

  const handleSynchMaterial = async () => {
    if (materialSynch === "") {
      return showDialog("Please Fill Out Material Field");
    }
    const params = {
      P_material: materialSynch,
      P_DistChannel: distChannelSynch,
    };
    try {
      const response = await dispatch(postSynchMaterial(params));
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.message);
        // if (action.isConfirmed) await window.location.reload();
      } else {
        showErrorDialog(response.payload.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  // synch material ext

  const [showMaterialExt, setShowMaterialExt] = useState(false);
  const handleCloseMaterialExt = () => setShowMaterialExt(false);
  const handleShowMaterialExt = () => setShowMaterialExt(true);

  const [tableName, setTableName] = useState("");
  const [ic4, setIc4] = useState("");
  const [docCat, setDocCat] = useState("");
  const [cg1, setCg1] = useState("");
  const [plant, setPlant] = useState("");
  const [salesOrg, setSalesOrg] = useState("");

  const handleSynchMaterialExt = async () => {
    if (materialSynch === "") {
      return showDialog("Please Fill Out Material Field");
    }
    // if (salesOrg === "") {
    //   return showDialog("Please Fill Out sales Org Field");
    // }
    const params = {
      tableName: tableName,
      P_SalesOrg: salesOrg,
      P_Material: materialSynch,
      P_Customer: customerCodeSynch,
      P_Batch: batch,
      P_Plant: plant,
      P_IC4: ic4,
      P_DocCat: docCat,
      P_CG1: cg1,
    };
    console.log(params, "params");
    try {
      const response = await dispatch(postSynchMaterialExt(params));
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.message);
        // if (action.isConfirmed) await window.location.reload();
      } else {
        showErrorDialog(response.payload.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  return (
    <>
      <Card>
        <CardHeader title="With Rtv List">
          <CardHeaderToolbar>
            <ButtonGroup>
              <DropdownButton
                as={ButtonGroup}
                title="Synch"
                id="bg-nested-dropdown"
              >
                <Dropdown.Item eventKey="1" onClick={handleSynchCrprpg}>
                  Crp Rgp
                </Dropdown.Item>
                <Dropdown.Item eventKey="2" onClick={handleShowCustomer}>
                  Customer
                </Dropdown.Item>
                <Dropdown.Item eventKey="2" onClick={handleShowMaterialSynch}>
                  Material
                </Dropdown.Item>
                <Dropdown.Item eventKey="2" onClick={handleShowMaterialExt}>
                  Material Exc
                </Dropdown.Item>
              </DropdownButton>
            </ButtonGroup>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          {/* Filter */}
          <Form>
            <Form.Group as={Row}>
              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>RTV Number</b>
                  </Form.Label>
                  <Col sm={5}>
                    <Form.Control type="text" disabled value={dataRtv.rtvNo} />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>RTV Date</b>
                  </Form.Label>
                  <Col sm={5}>
                    <Form.Control
                      type="text"
                      disabled
                      value={dataRtv.rtvDate}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>RTV Receiving Date</b>
                  </Form.Label>
                  <Col sm={5}>
                    <Form.Control
                      type="text"
                      disabled
                      value={dataRtv.rtvReceivingDate}
                    />
                  </Col>
                </Form.Group>
              </Col>
              {/* Right Row */}
              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>
                      Customer Name <b className="color-red">*</b>
                    </b>
                  </Form.Label>
                  <Col sm={5}>
                    <Form.Control
                      type="text"
                      disabled
                      value={dataRtv.customerName}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Customer Code</b>
                  </Form.Label>
                  <Col sm={5}>
                    <Form.Control
                      type="text"
                      disabled
                      value={dataRtv.customerCode}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Sales Division</b>
                  </Form.Label>
                  <Col sm={5}>
                    <Form.Control
                      type="text"
                      disabled
                      value={dataRtv.salesDivision}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Distribution Channel</b>
                  </Form.Label>
                  <Col sm={5}>
                    <Form.Control
                      type="text"
                      disabled
                      value={dataRtv.distributionChannel}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Form.Group>
          </Form>
          {/* Footer */}
          <Row className="mt-4 mb-5">
            <Col sm={2}>
              {tableData.length < 1 && (
                <Button
                  className={` mb-5
                      ${invoiceNo !== "" ? "hide" : ""}
                      ${taxInvoice !== "" ? "hide" : ""}
                      ${poNumber !== "" ? "hide" : ""}
                      ${materialCodeFilter !== "" ? "hide" : ""}
                      ${materialNameFilter !== "" ? "hide" : ""}     
                      ${
                        tableDataInvoice.length > 0 ? "hide" : ""
                      }                 
                      `}
                  variant="info"
                  onClick={handleShowMaterial}
                >
                  Non Reference
                </Button>
              )}
              {tableData.length > 0 && (
                <Button
                  className={` mb-5
                      ${invoiceNo !== "" ? "hide" : ""}
                      ${taxInvoice !== "" ? "hide" : ""}
                      ${poNumber !== "" ? "hide" : ""}
                      ${materialCodeFilter !== "" ? "hide" : ""}
                      ${materialNameFilter !== "" ? "hide" : ""}     
                      ${
                        tableDataInvoice.length > 0 ? "hide" : ""
                      }                 
                      `}
                  variant="info"
                  onClick={handleShowMaterial}
                >
                  Add Material
                </Button>
              )}
            </Col>
            <Col sm={2}>
              {tableDataInvoice.length < 1 && tableData.length < 1 && (
                <Button
                  className={`btn btn-primary mb-5 mr-0${
                    tableData.length > 0 ? "hide" : ""
                  }`}
                  // onClick={handleSearch}
                  onClick={handleShowInvoice}
                >
                  Reference
                </Button>
              )}
              {tableDataInvoice.length > 0 && (
                <Button
                  className={`btn btn-primary mb-5 ${
                    tableData.length > 0 ? "hide" : ""
                  }`}
                  // onClick={handleSearch}
                  onClick={handleShowInvoice}
                >
                  Add Reference
                </Button>
              )}
            </Col>
            <Col sm={1}>
              <Button
                variant="outline-danger"
                onClick={() => history.push("/new-return/with-rtv")}
              >
                Back
              </Button>
            </Col>
          </Row>

          {/* Table Ref*/}
          {tableDataInvoice.length > 0 && (
            <WithRtvTable
              className="mb-5"
              data={tableDataInvoice}
              deleteRow={handleDeleteRowInvoice}
              rtv={dataRtv}
              page={pageNo}
              sizePerPage={pageSize}
              totalSize={totalRecord}
              // onTableChange={handleTableChange}
              loading={loading}
            />
          )}

          {/* Table Non Ref*/}
          {tableData.length > 0 && (
            <WithRtvNonRefTable
              deleteRow={handleDeleteRow}
              data={tableData}
              rtv={dataRtv}
              page={pageNo}
              sizePerPage={pageSize}
              totalSize={totalRecord}
              // onTableChange={handleTableChange}
              loading={loading}
            />
          )}
        </CardBody>
      </Card>

      {/* Add Material */}

      <Modal
        show={showMaterial}
        onHide={handleCloseMaterial}
        dialogClassName="modal-width"
      >
        <LoadingFetchData active={overlayStateMaterial} />
        <Modal.Header closeButton>
          <Modal.Title>Material Search</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group as={Row}>
              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Material Code</b>
                  </Form.Label>
                  <Col sm={5}>
                    <Form.Control
                      onChange={(e) => {
                        setMaterialCode(e.target.value);
                      }}
                      value={materialCode}
                      required
                      type="text"
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Batch</b>
                  </Form.Label>
                  <Col sm={5}>
                    <Form.Control
                      onChange={(e) => {
                        setBatch(e.target.value);
                      }}
                      value={batch}
                      required
                      type="text"
                    />
                  </Col>
                </Form.Group>
              </Col>
              {/* Right Row */}
              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Material Name</b>
                  </Form.Label>
                  <Col sm={5}>
                    <Form.Control
                      onChange={(e) => {
                        setMaterialName(e.target.value);
                      }}
                      value={materialName}
                      required
                      type="text"
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Form.Group>

            <Button
              className="mb-5"
              variant="secondary"
              onClick={handleSearchMaterial}
            >
              Search
            </Button>
          </Form>
          {showResultsMaterial > 0 && (
            <BootstrapTable
              remote
              wrapperClasses="table-responsive"
              classes="table table-head-custom table-vertical-center overflow-hidden"
              bootstrap4
              bordered={false}
              keyField="uuid"
              data={tableDataMaterial}
              columns={columnsMaterial}
              pagination={paginationFactory(optionsMaterial)}
              onTableChange={handleTableChangeMaterial}
              selectRow={onSelectRow}
              rowClasses={rowClasses}
              hover
            />
          )}
        </Modal.Body>
        {showResultsMaterial > 0 && (
          <Modal.Footer>
            <Row className="mt-4">
              <Col>
                <Button
                  variant="success"
                  onClick={() => {
                    updateTableDataFromMaterialTable();
                  }}
                >
                  Choose
                </Button>
              </Col>
              <Col>
                <Button variant="outline-danger" onClick={handleCloseMaterial}>
                  Back
                </Button>
              </Col>
            </Row>
          </Modal.Footer>
        )}
      </Modal>

      {/* Add Invoice */}

      <Modal
        show={showInvoice}
        onHide={handleCloseInvoice}
        dialogClassName="modal-width"
      >
        <LoadingFetchData active={overlayStateInvoice} />
        <Modal.Header closeButton>
          <Modal.Title>Reference</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group as={Row}>
              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Invoice Ref Num</b>
                  </Form.Label>
                  <Col sm={5}>
                    <Form.Control
                      type="text"
                      onChange={(e) => {
                        setInvoiceNo(e.target.value);
                      }}
                      value={invoiceNo}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Tax Invoice Ref Num</b>
                  </Form.Label>
                  <Col sm={5}>
                    <Form.Control
                      type="text"
                      onChange={(e) => {
                        setTaxInvoice(e.target.value);
                      }}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>PO Ref Number</b>
                  </Form.Label>
                  <Col sm={5}>
                    <Form.Control
                      type="text"
                      onChange={(e) => {
                        setPoNumber(e.target.value);
                      }}
                    />
                  </Col>
                </Form.Group>
              </Col>
              {/* Right Row */}
              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Material Code</b>
                  </Form.Label>
                  <Col sm={5}>
                    <Form.Control
                      type="text"
                      onChange={(e) => {
                        setMaterialCodeFilter(e.target.value);
                      }}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Material Name</b>
                  </Form.Label>
                  <Col sm={5}>
                    <Form.Control
                      type="text"
                      onChange={(e) => {
                        setMaterialNameFilter(e.target.value);
                      }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Form.Group>

            <Button
              className="mb-5"
              variant="secondary"
              onClick={handleSearchInvoice}
            >
              Search
            </Button>
          </Form>
          {showResultsInvoice > 0 && (
            <div className="table-container">
              <BootstrapTable
                remote
                // wrapperClasses="table-responsive"
                classes="table table-head-custom table-vertical-center"
                bootstrap4
                bordered={false}
                keyField="uuid"
                data={dataInvoice}
                columns={columnsInvoice}
                pagination={paginationFactory(optionsInvoice)}
                onTableChange={handleTableChangeInvoice}
                selectRow={onSelectRowInvoice}
                rowClasses={rowClassesInvoice}
                hover
              />
            </div>
          )}
        </Modal.Body>
        {showResultsInvoice > 0 && (
          <Modal.Footer>
            <Row className="mt-4">
              <Col>
                <Button
                  variant="success"
                  onClick={() => {
                    handleSubmit();
                  }}
                >
                  Choose
                </Button>
              </Col>
              <Col>
                <Button variant="outline-danger" onClick={handleCloseInvoice}>
                  Back
                </Button>
              </Col>
            </Row>
          </Modal.Footer>
        )}
      </Modal>

      {/* Modal synch customer */}
      <Modal
        show={showCustomer}
        onHide={handleCloseCustomer}
        dialogClassName="modal-synch"
      >
        <Modal.Header closeButton>
          <Modal.Title>{}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group as={Row}>
              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>
                      Customer Code <b className="color-red">*</b>
                    </b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control
                      required
                      type="text"
                      onChange={(e) => {
                        setCustomerCodeSynch(e.target.value);
                      }}
                      value={customerCodeSynch}
                    />
                  </Col>
                </Form.Group>
              </Col>
              {/* Right Row */}
              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Customer Name</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control
                      required
                      type="number"
                      onChange={(e) => {
                        setCustomerNameSynch(e.target.value);
                      }}
                      value={customerNameSynch}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseCustomer}>
            Close
          </Button>
          <Button variant="primary" onClick={handleSynchCustomer}>
            Synch
          </Button>
        </Modal.Footer>{" "}
      </Modal>

      {/* Modal synch material */}
      <Modal
        show={showMaterialSynch}
        onHide={handleCloseMaterialSynch}
        dialogClassName="modal-synch"
      >
        <Modal.Header closeButton>
          <Modal.Title>Material</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group as={Row}>
              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>
                      Material <b className="color-red">*</b>
                    </b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control
                      required
                      type="text"
                      onChange={(e) => {
                        setMaterialSynch(e.target.value);
                      }}
                      value={materialSynch}
                    />
                  </Col>
                </Form.Group>
              </Col>
              {/* Right Row */}
              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Dist Channel</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control
                      required
                      type="text"
                      onChange={(e) => {
                        setDistChannelSynch(e.target.value);
                      }}
                      value={distChannelSynch}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseMaterialSynch}>
            Close
          </Button>
          <Button variant="primary" onClick={handleSynchMaterial}>
            Sync
          </Button>
        </Modal.Footer>{" "}
      </Modal>

      {/* Modal synch materialExt */}
      <Modal
        show={showMaterialExt}
        onHide={handleCloseMaterialExt}
        dialogClassName="modal-synch"
      >
        <Modal.Header closeButton>
          <Modal.Title>Material Ext</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group as={Row}>
              <Col sm={6}>
                {/* <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Table Name</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control
                      required
                      type="text"
                      onChange={(e) => {
                        setTableName(e.target.value);
                      }}
                      value={tableName}
                      placeholder="KOTG619"
                    />
                  </Col>
                </Form.Group> */}
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>
                      Sales Org <b className="color-red">*</b>
                    </b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control
                      required
                      type="text"
                      onChange={(e) => {
                        setSalesOrg(e.target.value);
                      }}
                      value={salesOrg}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>
                      Material <b className="color-red">*</b>
                    </b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control
                      required
                      type="text"
                      onChange={(e) => {
                        setMaterialSynch(e.target.value);
                      }}
                      value={materialSynch}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Customer</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control
                      required
                      type="text"
                      onChange={(e) => {
                        setCustomerCodeSynch(e.target.value);
                      }}
                      value={customerCodeSynch}
                    />
                  </Col>
                </Form.Group>
              </Col>
              {/* Right Row */}
              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Batch</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control
                      required
                      type="text"
                      onChange={(e) => {
                        setBatch(e.target.value);
                      }}
                      value={batch}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Plant</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control
                      required
                      type="text"
                      onChange={(e) => {
                        setPlant(e.target.value);
                      }}
                      value={plant}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>IC4</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control
                      required
                      type="text"
                      onChange={(e) => {
                        setIc4(e.target.value);
                      }}
                      value={ic4}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>DocCat</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control
                      required
                      type="text"
                      onChange={(e) => {
                        setDocCat(e.target.value);
                      }}
                      value={docCat}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>CG1</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control
                      required
                      type="text"
                      onChange={(e) => {
                        setCg1(e.target.value);
                      }}
                      value={cg1}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseMaterialExt}>
            Close
          </Button>
          <Button variant="primary" onClick={handleSynchMaterialExt}>
            Sync
          </Button>
        </Modal.Footer>{" "}
      </Modal>
    </>
  );
};
